module.exports = __webpack_public_path__ + "static/media/modifySvg.6e63db70.svg";